'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var language = require('@gig/magic-sdk/dist/adapter/users/language');
var getCountries = require('@gig/magic-sdk/dist/adapter/users/getCountries');
var signup = require('@gig/magic-sdk/dist/adapter/users/signup');
var config = require('../../config/config.js');

const LANGUAGE_TO_CURRENCY = {
  [language.Language.BRITISH]: signup.Currency.GBP,
  [language.Language.SWEDISH]: signup.Currency.SEK,
  [language.Language.FINNISH]: signup.Currency.EUR,
  [language.Language.GERMAN]: signup.Currency.EUR,
  [language.Language.NEW_ZEALAND]: signup.Currency.NZD,
  [language.Language.NORWEGIAN]: signup.Currency.NOK,
  [language.Language.TURKISH]: signup.Currency.EUR,
  [language.Language.ENGLISH]: signup.Currency.EUR,
  [language.Language.CANADIAN]: signup.Currency.CAD,
  [language.Language.AUSTRALIAN]: signup.Currency.AUD,
  [language.Language.DUTCH]: signup.Currency.EUR,
  [language.Language.DANISH]: signup.Currency.DKK,
  [language.Language.RUSSIAN]: signup.Currency.EUR,
  [language.Language.LATVIAN]: signup.Currency.EUR,
  [language.Language.SPANISH]: signup.Currency.EUR,
  [language.Language.MACEDONIAN]: signup.Currency.MKD,
  [language.Language.HUNGARIAN]: signup.Currency.HUF,
  [language.Language.CANADIAN_FRENCH]: signup.Currency.CAD,
  [language.Language.JAPANESE]: signup.Currency.JPY,
  [language.Language.HINDI]: signup.Currency.INR,
  [language.Language.THAI]: signup.Currency.THB,
  [language.Language.ARGENTINE_SPANISH]: signup.Currency.ARS,
  [language.Language.ROMANIAN]: signup.Currency.RON,
  [language.Language.SOUTH_AFRICAN]: signup.Currency.ZAR,
  [language.Language.CHILEAN]: signup.Currency.CLP,
  [language.Language.MANDARIN]: signup.Currency.USD,
  [language.Language.PERU]: signup.Currency.PEN,
  [language.Language.BRAZILIAN_PORTUGUESE]: signup.Currency.BRL,
  [language.Language.ESTONIAN]: signup.Currency.EUR,
  [language.Language.IRISH]: signup.Currency.EUR
};
function languageToCurrency(language, defaultCurrency = signup.Currency.EUR) {
  return LANGUAGE_TO_CURRENCY[language] || defaultCurrency;
}
const COUNTRY_TO_CURRENCY = {
  [getCountries.Country.UNITED_KINGDOM]: signup.Currency.GBP,
  [getCountries.Country.NEW_ZEALAND]: signup.Currency.NZD,
  [getCountries.Country.SWEDEN]: signup.Currency.SEK,
  [getCountries.Country.NORWAY]: signup.Currency.NOK,
  [getCountries.Country.CANADA]: signup.Currency.CAD,
  [getCountries.Country.SOUTH_AFRICA]: signup.Currency.ZAR,
  [getCountries.Country.ARGENTINA]: signup.Currency.ARS,
  [getCountries.Country.ROMANIA]: signup.Currency.RON,
  [getCountries.Country.CHILE]: signup.Currency.CLP,
  [getCountries.Country.PERU]: signup.Currency.PEN,
  [getCountries.Country.BRAZIL]: signup.Currency.BRL
};
function countryToCurrency(country, defaultCurrency = signup.Currency.EUR) {
  return COUNTRY_TO_CURRENCY[country] || defaultCurrency;
}
function convertCurrency(value, currency) {
  const multiplier = config.magicConfig.currencyMultipliers[currency];
  if (!multiplier) {
    throw new Error(`Conversion failed, missing ${currency} multiplier`);
  }
  const result = value * multiplier;
  if (Number.isInteger(result)) {
    return result;
  }
  return parseFloat((value * multiplier).toFixed(2));
}

exports.convertCurrency = convertCurrency;
exports.countryToCurrency = countryToCurrency;
exports.languageToCurrency = languageToCurrency;
